import http from './http';
import { listResource } from './listResource';

export async function listNotifications(options = {}) {
  return listResource('/notifications', options);
}

/**
 * Obtiene un notificación por su ID.
 */
export async function getNotificationById(id) {
  const res = await http.get(`/notifications/${id}`);
  return res.data?.data ?? res.data;
}

/**
 * Obtiene la lista de roles.
 */
export async function listRoles() {
  const res = await http.get('/roles');
  return res.data?.data ?? res.data ?? [];
}

/**
 * Obtiene la lista de módulos.
 */
export async function listModules() {
  const res = await http.get('/modules');
  return res.data?.data ?? res.data ?? [];
}

/**
 * Obtiene la lista de notifiaciones disponibles.
 */
export async function listNotificationsOptions() {
  const res = await http.get('/notification-settings');
  return res.data?.data ?? res.data ?? [];
}

/**
 * Actualiza un notificación.
 */
export async function updateNotification(id, userData) {
  const res = await http.put(`/notifications/${id}`, userData);
  return res.data?.data ?? res.data;
}

/**
 * Crear un notificación.
 */
export async function createNotification(id, userData) {
  const res = await http.post(`/notifications/${id}`, userData);
  return res.data?.data ?? res.data;
}

/**
 * Activar/Desactivar notificación
 */
export const updateNotificationstatus = (id, isActive) =>
  // eslint-disable-next-line camelcase
  http.patch(`/notifications/${id}/status`, { is_active: isActive });

/**
 * Eliminar notificación
 */
export const deleteNotification = (id) => http.delete(`/notifications/${id}`);
